import { FC } from 'react';
import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from '@gn-audio/jss-components';

import { LinkBlockComponent } from 'composables/shared/LinkBlock/LinkBlockComponent';
import { LinkBlockItem } from 'composables/shared/LinkBlock/LinkBlockItem.model';

type LinkBlockFields = {
  items: LinkBlockItem[];
  headline: Field<string>;
  backgroundColor: Field<string>;
};

export type LinkBlockProps = ComponentProps & {
  fields: LinkBlockFields;
};

export const LinkBlock: FC<LinkBlockProps> = ({ fields }) => {
  const { items: links, headline, backgroundColor } = fields;
  return <LinkBlockComponent links={links} headline={headline} backgroundColor={backgroundColor} />;
};

export default withDatasourceCheck()<LinkBlockProps>(LinkBlock);
